<template>
  <div class="edit-skills part-content">
    <h4 v-translate class="heading-4">Key skills (optional)</h4>
    <form v-if="skillsListState" @submit.prevent>
      <b-field
        :type="getErrorStatus"
        :message="errors"
        :label="labels.fieldLabel"
        class="form-field"
      >
        <multiselect-field :placeholder="labels.placeholder"
                           :tagPlaceholder="labels.tagPlaceholder"
                           :options="[]"
                           :value="skillsListState"
                           :taggable="true"
                           :multiple="true"
                           :iconField="true"
                           :close-on-select="false"
                           :clear-on-select="true"
                           :showOptionsList="false"
                           :showLabels="false"
                           :big-input-font-size="true"
                           :has-validation-error="!!errors.length"
                           @blur="errors=[]"
                           @tag="addSkill($event); setHasChanges(true)"
                           @remove="removeSkillItemState($event); setHasChanges(true)">
          <template slot="multiselect-icon">
            <div class="tag-icon">
              <svg-icon name="star-on" width="16" height="16"></svg-icon>
            </div>
          </template>
        </multiselect-field>
      </b-field>
    </form>
  </div>
</template>

<script>

import 'top20common/distribution/icons/star-on';

import MultiselectField from 'top20common/components/MultiselectField';
import {mapGetters, mapMutations} from 'vuex';

import validation from '@/services/validation';

export default {
  mounted() {
    this.$emit('form-filled', this.skillsHasValuesState);
  },
  data() {
    return {
      errors: []
    };
  },
  watch: {
    skillsHasValuesState(newValue) {
      this.$emit('form-filled', newValue);
    }
  },
  computed: {
    ...mapGetters(['skillsListState', 'skillsHasValuesState', 'partHasChangesState']),
    labels() {
      return {
        fieldLabel: this.$gettext("Only add skills you're confident about"),
        placeholder: this.$gettext('Type to add'),
        tagPlaceholder: this.$gettext('Press enter to add')
      };
    },
    getErrorStatus() {
      return this.errors.length ? 'is-danger' : '';
    }
  },
  methods: {
    ...mapMutations(['removeSkillItemState']),
    addSkill(value) {
      value = value.trim();
      this.errors = [];
      let message = validation.maxLength(255)(value);
      if (message) {
        this.$mam.trackProfileValidationError({skills_list: message});
        return this.errors.push(message);
      }
      this.$store.commit('addSkillItemState', value);
    },
    saveSkills(data) {
      return this.$store
        .dispatch('saveSkillsAction', data)
        .then(() => {
          this.$toast.open({message: this.$gettext('Skills saved'), type: 'is-success'});
        })
        .catch(() => {
          this.$toast.open({message: this.$gettext('Skills not saved'), type: 'is-danger'});
        });
    },
    save() {
      return new Promise((resolve, reject) => {
        if (this.partHasChangesState.skills) {
          this.saveSkills([...this.skillsListState])
            .then(resolve)
            .catch(reject);
        } else {
          resolve();
        }
        this.setHasChanges(false);
      });
    },
    validate() {
      return new Promise((resolve, reject) => {
        return resolve();
      });
    },
    setHasChanges(value) {
      this.$store.commit('mutatePartHasChangesState', {skills: value});
    }
  },
  components: {MultiselectField}
};
</script>

<style lang="scss" scoped>
.form-field {
  margin-top: 20px;
  .input {
    margin-top: 5px;
  }
  /deep/ .svg-icon {
    fill: var(--gray);
  }
}
</style>
